import { Route } from '@angular/router';

import { AUTH_ROUTES } from './shared/auth/auth.routes';
import { MOBILE_MAIN_ROUTES } from './mobile/main/main.routes';
import { DESKTOP_MAIN_ROUTES } from './desktop/main/main.routes';
import { guestGuard } from './core/guards/guest.guard';

export const APP_ROUTES: Route[] = [
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./privacy-policy/privacy-policy.component').then(c => c.PrivacyPolicyComponent),
  },
  {
    path: 'support',
    loadComponent: () => import('./support/support.component').then(c => c.SupportComponent),
  },
  {
    path: 'mobile',
    loadComponent: () => import('./mobile/layout.component').then(c => c.LayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full',
      },
      {
        path: 'main',
        loadComponent: () => import('./mobile/main/main.component').then(c => c.MainComponent),
        children: [...MOBILE_MAIN_ROUTES],
      },
      {
        path: 'auth',
        canActivate: [guestGuard],
        loadComponent: () => import('./shared/auth/auth.component').then(c => c.AuthComponent),
        children: [...AUTH_ROUTES],
      },
    ],
  },
  {
    path: 'desktop',
    loadComponent: () => import('./desktop/layout.component').then(c => c.LayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full',
      },
      {
        path: 'auth',
        canActivate: [guestGuard],
        loadComponent: () => import('./shared/auth/auth.component').then(c => c.AuthComponent),
        children: [...AUTH_ROUTES],
      },
      {
        path: 'main',
        loadComponent: () => import('./desktop/main/main.component').then(c => c.MainComponent),
        children: [...DESKTOP_MAIN_ROUTES],
      },
    ],
  },
];
